<template>
      <div class="sellerCroact">
         <div class="manage-table">
            <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="false"  :rowKey="(record,index)=>{return index}" >
                <div slot="contractUrl" slot-scope="text,record">
                <a-button type="primary"  @click="getDetail(text)">查看</a-button>
                </div>  
           </a-table>
         </div>   
      </div>  
</template>
<script>
const columns = [
   {
      title: '序号',
      dataIndex: 'projectCode',
      width: 200,
       customRender: (text,record,index) => `${index+1}`,
   },
   {
      title: '项目名称',
      dataIndex: 'projectName',
   },
   {
      title: '交易方式',
      dataIndex: 'wayToTrade',
   },
  {
      title:'文件',
      dataIndex:'contractUrl',
      scopedSlots: { customRender: 'contractUrl' },
  }
]   
export default {
   data(){
       return{
           columns:columns,
           data:[],
           total:0,
           loading:false,
       }
   },
   created(){
      this.$parent.activeIndex = 6;
      this.getDataList();
   },
   methods:{
      getDataList(){
         this.loading = true;
         this.$https.get('/portal/contract/getBuyerContractList').then(res=>{
            res.forEach(item => {
                   let arr = [];
                   arr.push(item.contractUrl);
                   item.pictureUrl = arr;
            });
            this.data = res;
            this.loading = false;
         }).catch(error=>{
              this.loading = false;
         })
      },
      getDetail(url){
          window.open(url)
      }
   }
}
</script>
<style lang="less" scoped>

</style>

